// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"66437aca","419":"701e6cf9","563":"fcf9143c","990":"993bc428"}[chunkId] + ".chunk.js";
};